// AUTO-GENERATED by scripts/build-icons.mjs — do not edit by hand.
import { createSvgIconFromGenerated } from '../utils'

import SvgArrow from './svg-arrow'
import SvgArrowLeft from './svg-arrow-left'
import SvgCancel from './svg-cancel'
import SvgCheckedCircleIcon from './svg-checked-circle-icon'
import SvgGift from './svg-gift'
import SvgSliderArrowLeft from './svg-slider-arrow-left'
import SvgSliderArrowRight from './svg-slider-arrow-right'
import SvgTickleDarkDesktop from './svg-tickle-dark-desktop'
import SvgTickleDarkMobile from './svg-tickle-dark-mobile'
import SvgTickleLightDesktop from './svg-tickle-light-desktop'
import SvgTickleLightMobile from './svg-tickle-light-mobile'

export const ArrowIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgArrow, 'Arrow')
export const ArrowLeftIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgArrowLeft, 'ArrowLeft')
export const CancelIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCancel, 'Cancel')
export const CheckedCircleIconIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCheckedCircleIcon, 'CheckedCircleIcon')
export const GiftIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgGift, 'Gift')
export const SliderArrowLeftIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSliderArrowLeft, 'SliderArrowLeft')
export const SliderArrowRightIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSliderArrowRight, 'SliderArrowRight')
export const TickleDarkDesktopIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTickleDarkDesktop, 'TickleDarkDesktop')
export const TickleDarkMobileIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTickleDarkMobile, 'TickleDarkMobile')
export const TickleLightDesktopIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTickleLightDesktop, 'TickleLightDesktop')
export const TickleLightMobileIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTickleLightMobile, 'TickleLightMobile')
